export const depotGasWay = Object.freeze({
  basUrl: '/cnpc/gas/optimal/depot',
  updateSome: '/cnpc/gas/optimal/depot/partly'
})

export const gasDepotDraft = Object.freeze({
  push: '/cnpc/depot/optimal/publish',
  basUrl: '/cnpc/depot/draft/default'
})

export const gasDepot = Object.freeze({
  basUrl: '/cnpc/depot/gas/default',
  outPut: '/cnpc/otherbus/excel/depot/default/published'
})

export const gasDepotPriority = Object.freeze({
  basUrl: '/cnpc/depot/optimal/publish',
  outPut: '/cnpc/otherbus/excel/depot/optimal/published'
})

export const gasDepotPublish = Object.freeze({
  basUrl: '/cnpc/depot/publish/log'
})

export const depotTank = Object.freeze({
  basUrl: '/cnpc/depot/tank',
  parmUrl: (id) => `/cnpc/depot/tank/${id}`
})

export const depotInvoicing = Object.freeze({
  basUrl: '/cnpc/depot/tank/daily',
  input: '/cnpc/depot/tank/daily/batch/insert'
})



// WEBPACK FOOTER //
// ./src/api/ycUrl.js